/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParcDto } from './ParcDto';
import {
    ParcDtoFromJSON,
    ParcDtoFromJSONTyped,
    ParcDtoToJSON,
    ParcDtoToJSONTyped,
} from './ParcDto';

/**
 * 
 * @export
 * @interface GetParcImmobilierResponseDto
 */
export interface GetParcImmobilierResponseDto {
    /**
     * 
     * @type {ParcDto}
     * @memberof GetParcImmobilierResponseDto
     */
    realEstatePark: ParcDto;
}

/**
 * Check if a given object implements the GetParcImmobilierResponseDto interface.
 */
export function instanceOfGetParcImmobilierResponseDto(value: object): value is GetParcImmobilierResponseDto {
    if (!('realEstatePark' in value) || value['realEstatePark'] === undefined) return false;
    return true;
}

export function GetParcImmobilierResponseDtoFromJSON(json: any): GetParcImmobilierResponseDto {
    return GetParcImmobilierResponseDtoFromJSONTyped(json, false);
}

export function GetParcImmobilierResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetParcImmobilierResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'realEstatePark': ParcDtoFromJSON(json['realEstatePark']),
    };
}

export function GetParcImmobilierResponseDtoToJSON(json: any): GetParcImmobilierResponseDto {
    return GetParcImmobilierResponseDtoToJSONTyped(json, false);
}

export function GetParcImmobilierResponseDtoToJSONTyped(value?: GetParcImmobilierResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'realEstatePark': ParcDtoToJSON(value['realEstatePark']),
    };
}

